/* Shared Logic for Search and Collection Hero Sections */

document.addEventListener('DOMContentLoaded', function() {
  // 1. Layout Toggle Logic
  const overviewBtn = document.getElementById('overviewBtn');
  const gridBtn = document.getElementById('gridBtn');
  const productGrid = document.querySelector('.custom-product-grid');
  
  if (overviewBtn && gridBtn && productGrid) {
    overviewBtn.addEventListener('click', function() {
      gridBtn.classList.remove('active');
      overviewBtn.classList.add('active');
      productGrid.classList.add('overview-layout');
      localStorage.setItem('hero-layout-view', 'overview');
    });
    
    gridBtn.addEventListener('click', function() {
      overviewBtn.classList.remove('active');
      gridBtn.classList.add('active');
      productGrid.classList.remove('overview-layout');
      localStorage.setItem('hero-layout-view', 'grid');
    });

    // Restore saved layout
    const savedLayout = localStorage.getItem('hero-layout-view');
    if (savedLayout === 'overview') {
      overviewBtn.click();
    }
  }

  // 2. Filter Panel Logic
  const filterToggleBtn = document.getElementById('filterToggleBtn');
  const filterPanel = document.getElementById('filterPanel');
  const filterOverlay = document.getElementById('filterOverlay');
  const filterCloseBtn = document.getElementById('filterCloseBtn');
  
  if (filterToggleBtn && filterPanel) {
    filterToggleBtn.addEventListener('click', () => {
      filterPanel.classList.add('active');
      if (filterOverlay) filterOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    });
  }
  
  const closePanel = () => {
    if (filterPanel) filterPanel.classList.remove('active');
    if (filterOverlay) filterOverlay.classList.remove('active');
    document.body.style.overflow = '';
  };

  if (filterOverlay) filterOverlay.addEventListener('click', closePanel);
  if (filterCloseBtn) filterCloseBtn.addEventListener('click', closePanel);

  // Filter Chip Logic (Navigational)
  document.querySelectorAll('.filter-chip').forEach(chip => {
    chip.addEventListener('click', function() {
      const url = this.dataset.url;
      if (url) {
        window.location.href = url;
      }
    });
  });

  // Price Range Filter Logic
  document.querySelectorAll('.filter-apply-btn').forEach(btn => {
    btn.addEventListener('click', function() {
      const parent = this.closest('.filter-section');
      if (!parent) return;
      
      const inputs = parent.querySelectorAll('input');
      const url = new URL(window.location.href);
      
      inputs.forEach(input => {
        if (input.value) {
          url.searchParams.set(input.name, input.value);
        } else {
          url.searchParams.delete(input.name);
        }
      });
      
      // Remove pagination if applying new filters
      url.searchParams.delete('page');
      
      window.location.href = url.toString();
    });
  });

  // 3. Quick Add Logic
  // Variant selection
  document.querySelectorAll('.size-option').forEach(option => {
    option.addEventListener('click', function() {
      const card = this.closest('.custom-product-card');
      const siblings = card.querySelectorAll('.size-option');
      siblings.forEach(s => s.classList.remove('selected'));
      this.classList.add('selected');
      
      const quickAddBtn = card.querySelector('.quick-add-btn');
      if (quickAddBtn) {
        quickAddBtn.dataset.variantId = this.dataset.variantId;
        quickAddBtn.textContent = 'Add to Cart';
        quickAddBtn.disabled = false;
      }
    });
  });

  // Add to cart
  document.querySelectorAll('.quick-add-btn').forEach(btn => {
    btn.addEventListener('click', function() {
      const variantId = this.dataset.variantId;
      if (!variantId) {
        alert('Please select a size first');
        return;
      }

      this.disabled = true;
      this.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(response => response.json())
      .then(data => {
        this.textContent = 'Added!';
        setTimeout(() => {
          this.textContent = 'Add to Cart';
          this.disabled = false;
        }, 2000);
        // Dispatch event for cart update if theme supports it
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
        window.location.href = '/cart'; // Redirect to cart for simplicity
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        this.textContent = 'Error';
        this.disabled = false;
      });
    });
  });
});
